export default "__VITE_ASSET__2464e8c9__"